<template>
  <div>
    <Carousel :index="index" :data="getDetail" @closeGallery="closeGallery" />
    <div class="backdrop">
      <button @click="closeDetail" class="close-button">X</button>
      <div class="car-detail-panel">
        <div class="header" v-if="this.getDetail != null">
          <div
            class="state-offer"
            :class="{ reserved: !this.getDetail.SaleActive }"
          >{{ this.getDetail.SaleState }}</div>
          <div class="new-car" v-show="showNewLabel">Novinka</div>
          <div class="title">
            <h2>{{ getDetail.Name }}</h2>
          </div>
        </div>
        <Spinner v-show="isCarLoading" />
        <CarDetail v-show="!isCarLoading" :data="getDetail" @getCarousel="getCarousel" />
      </div>
    </div>
  </div>
</template>
<script>
import CarDetail from "./CarDetail";
import Spinner from "../../../UI/Spinner";
import Carousel from "./components/Carousel";
import { mapActions, mapMutations } from "vuex";

export default {
  components: {
    CarDetail,
    Spinner,
    Carousel
  },
  data() {
    return {
      index: null
    };
  },
  methods: {
    ...mapActions(["getCar"]),
    ...mapMutations,
    closeDetail() {
      this.clearCarDetail;
      if (this.$router.path != "/") this.$router.replace("/").catch(() => {});
    },
    getCarousel(index) {
      this.index = index;
    },
    closeGallery() {
      this.index = null;
    }
  },
  mounted() {
    if (this.$route.params.id) this.getCar(this.$route.params.id);
  },
  computed: {
    isCarLoading() {
      return this.$store.getters.isCarDetailLoading;
    },
    getDetail() {
      return this.$store.getters.getDetail;
    },
    showNewLabel() {
      let dt1 = new Date(this.getDetail.Created);
      let dt2 = new Date();
      let days = Math.floor(
        (Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) -
          Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) /
          (1000 * 60 * 60 * 24)
      );
      if (days < 14) return true;

      return false;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../../../scss/global.scss";
.backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 500;
  padding: 1rem;
  padding-top: 4.3rem;
}
::-webkit-scrollbar {
  display: none;
}
.car-detail-panel {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #fff;
  border-radius: 0.5rem;
  z-index: 600;
  padding: 0.5rem;
  padding-top: 6.5rem;
  overflow-x: hidden;
  overflow-y: auto;
  -ms-overflow-style: none; /* IE 11 */
  scrollbar-width: none; /* Firefox 64 */
}

.header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 7.2rem;
  overflow: hidden;
  z-index: 150;
  background-color: inherit;

  .title {
    padding: 0 1rem;
    padding-top: 1.9rem;
  }
  .new-car {
    width: 12rem;
    background-color: rgb(189, 176, 0);
    transform: rotate(-45deg);
    position: absolute;
    color: #fff;
    top: 1.2rem;
    left: -4.1rem;
    display: inline-block;
    text-align: center;
    font-size: 1rem;
  }
  .state-offer {
    width: 12rem;
    background-color: rgb(52, 68, 209);
    transform: rotate(45deg);
    position: absolute;
    color: #fff;
    top: 1.2rem;
    right: -4.1rem;
    text-align: center;
    font-size: 1rem;
    &.reserved {
      background-color: rgb(202, 68, 5);
    }
  }
}
.close-button {
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 3rem;
  height: 3rem;
  background-color: transparent;
  border: 6px solid #fff;
  border-radius: 50%;
  color: #fff;
  font-weight: 800;
  font-size: 1.2rem;
  cursor: pointer;
  padding: 0;
}
@media (min-width: $min-width-extended) {
  .backdrop {
    padding: 1rem 5rem;
  }
  .car-detail-panel {
    padding: 1rem;
    padding-top: 7.3rem;
  }
  .header {
    .title {
      padding: 0;
      padding-top: 1.3rem;
    }
    .new-car {
      top: 1.7rem;
      left: -3.2rem;
      font-size: 1.5rem;
    }
    .state-offer {
      top: 1.7rem;
      right: -3.2rem;
      font-size: 1.5rem;
    }
  }
}
</style>
